import { render, staticRenderFns } from "./SettingsTeam.vue?vue&type=template&id=a413b55e&scoped=true&lang=pug&"
import script from "./SettingsTeam.vue?vue&type=script&lang=js&"
export * from "./SettingsTeam.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTeam.vue?vue&type=style&index=0&id=a413b55e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a413b55e",
  null
  
)

export default component.exports